import { ChevronRightIcon } from '@chakra-ui/icons';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';

import styles from './nested-filter-select.module.css';

type NestedFilterSelectGroupProps = {
  label: string;
  children: ReactNode;
};

export function NestedFilterSelectGroup({
  label,
  children,
}: NestedFilterSelectGroupProps) {
  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger
        className={styles.subTrigger}
        data-testid={`data-builder-custom-filter-group-toggle-${label}`}
      >
        <span className={styles.subTriggerLabel}>{label}</span>
        <span className={styles.subChevron} aria-hidden="true">
          <ChevronRightIcon boxSize={4} />
        </span>
      </DropdownMenu.SubTrigger>
      <DropdownMenu.SubContent
        className={styles.subContent}
        sideOffset={4}
        alignOffset={-4}
        collisionPadding={8}
        avoidCollisions
      >
        {children}
      </DropdownMenu.SubContent>
    </DropdownMenu.Sub>
  );
}
